/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getLocationConfig} from '../api'

 export const useQueryGetLocationConfig = createReactQueryHook('getLocationConfig', getLocationConfig)
